module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.classes,
    style: ({
      display: 'block',
      zIndex: _vm.zindex
    })
  }, [_c('div', {
    class: _vm.dialogClasses
  }, [_c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm._close),
      expression: "_close"
    }],
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm._close
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('btn', {
    attrs: {
      "color": "dark",
      "outline": ""
    },
    on: {
      "click": _vm._close
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _vm._t("footer")], 2)])])]) : _vm._e()]), _vm._v(" "), (_vm.mask) ? _c('masker', {
    attrs: {
      "show": _vm.show,
      "zindex": _vm.zindex,
      "delay": 0.5
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3e1a690"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/modal.vue
// module id = 550
// module chunks = 84